import { ApiService } from '../services/api.service';
import { API_URL } from '../config/api.config';

// PROD const API_URL = 'https://api.toursbouillon.fr/api';
// const API_URL = 'http://localhost:3001/api';

export const createReservation = async (reservationData) => {
    console.log("reservationData1", reservationData);
    // Construire la date correctement en combinant date et heure
    // Envoyer directement la chaîne pour éviter les problèmes de fuseau horaire
    const dateTimeString = `${reservationData.reservationDate}T${reservationData.reservationTime}:00`;
    reservationData.reservationDate = dateTimeString;
    console.log("reservationData2", reservationData);
    return ApiService.fetch('/reservations', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(reservationData)
    });
};

export const getReservations = async () => {
    return ApiService.fetchWithAuth('/reservations');
};

export const getReservation = async (id) => {
    return ApiService.fetch(`/reservations/${id}`);
};

export const updateReservation = async (id, reservationData) => {
    return ApiService.fetch(`/reservations/${id}`, {
        method: 'PUT',
        body: JSON.stringify(reservationData)
    });
};

export const deleteReservation = async (id) => {
    return ApiService.fetch(`/reservations/${id}`, {
        method: 'DELETE'
    });
};

export const getUnavailableDates = async (startDate, endDate) => {
    try {
        const response = await fetch(`${API_URL}/unavailable-dates?startDate=${startDate}&endDate=${endDate}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error('Erreur lors de la récupération des dates non disponibles');
        }

        return await response.json();
    } catch (error) {
        console.error('Erreur:', error);
        throw error;
    }
};

export const checkDateAvailability = async (date) => {
    try {
        const response = await fetch(`${API_URL}/unavailable-dates/check-availability?date=${date}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error('Erreur lors de la vérification de la disponibilité');
        }

        return await response.json();
    } catch (error) {
        console.error('Erreur:', error);
        throw error;
    }
}; 